var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoostEfficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 42.4264,
    width: 59,
    height: 39,
    rx: 19.5,
    transform: "rotate(-45 0.707107 42.4264)",
    fill: "#F3FAFF",
    stroke: "#CEECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 35.5C43.5 40.4705 39.4705 44.5 34.5 44.5C29.5295 44.5 25.5 40.4705 25.5 35.5C25.5 30.5295 29.5295 26.5 34.5 26.5",
    stroke: "#175677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37.25C33.25 37.25 35 37 38.5 32.5",
    stroke: "#175677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 32.5H38.5V36.5M38.5 25.5V27.75M44.75 31.5H42.5M43.445 26.5L41.5 28.445",
    stroke: "#175677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostEfficiency);
export default __webpack_public_path__ + "static/media/Boost Efficiency.161bd6d397767068cf54a2d674be6cb8.svg";
export { ForwardRef as ReactComponent };